import React from "react";
import Navbar from "../components/Navbar";
import Hero from "../components/Hero";
import About from "../components/About";
import Services from "../components/Services";
import Pathology from "../components/Pathology";
import WhyMatters from "../components/WhyMatters";
import HowItWorks from "../components/HowItWorks";
import Doctors from "../components/Doctors";
import Accreditation from "../components/Accreditation";
import Nurses from "../components/Nurses";
import UniversityPartners from "../components/UniversityPartners";
import ClinicTour from "../components/ClinicTour";
import LatestNews from "../components/LatestNews";
import Contact from "../components/Contact";
import AfterHours from "../components/AfterHours";
import Footer from "../components/Footer";
import useSeo from "../hooks/useSeo";

export default function Home() {
  useSeo({
    title: "Beaudesert General Practice & Skin Cancer Clinic | Bulk-Billing Doctors, Beaudesert QLD",
    description: "100% bulk-billing family doctors, skin cancer clinic and on-site 4Cyte pathology in Beaudesert, QLD. RACGP, QPA & ACRRM accredited. Book on HotDoc or call (07) 5541 1011.",
    path: "/"
  });
  return (
    <div className="relative bg-[#f0edfa]" style={{ overflowX: "clip" }}>
      <Navbar />
      <Hero />
      <About />
      <Services />
      <Pathology />
      <WhyMatters />
      <HowItWorks />
      <Doctors />
      <Accreditation />
      <Nurses />
      <UniversityPartners />
      <ClinicTour />
      <LatestNews />
      <Contact />
      <AfterHours />
      <Footer />
    </div>
  );
}
